var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        _vm._b(
          {
            attrs: {
              title: _vm.title,
              visible: _vm.dialogFormVisible,
              width: "45%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogFormVisible = $event
              },
            },
          },
          "el-dialog",
          _vm.$attrs,
          false
        ),
        [
          _vm.add === "work"
            ? _c(
                "el-form",
                {
                  ref: "workForm",
                  attrs: {
                    model: _vm.workForm,
                    rules: _vm.workRules,
                    "label-width": "90px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-box" },
                    _vm._l(_vm.workList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "form-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: item.value } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v(_vm._s(item.label))]
                              ),
                              _vm._v(" "),
                              item.type === "date"
                                ? _c("el-date-picker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: item.placeholder,
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    model: {
                                      value: _vm.workForm[item.value],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.workForm, item.value, $$v)
                                      },
                                      expression: "workForm[item.value]",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "input"
                                ? _c("el-input", {
                                    attrs: {
                                      size: item.size || "small",
                                      clearable: "",
                                      placeholder: item.placeholder,
                                    },
                                    model: {
                                      value: _vm.workForm[item.value],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.workForm, item.value, $$v)
                                      },
                                      expression: "workForm[item.value]",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "textarea"
                                ? _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.workForm[item.value],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.workForm, item.value, $$v)
                                      },
                                      expression: "workForm[item.value]",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitFnn()
                            },
                          },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.add === "education"
            ? _c(
                "el-form",
                {
                  ref: "educationForm",
                  attrs: {
                    model: _vm.educationForm,
                    rules: _vm.educationRules,
                    "label-width": "90px",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-box" },
                    _vm._l(_vm.educationList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "form-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: item.value } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v(_vm._s(item.label))]
                              ),
                              _vm._v(" "),
                              item.type === "date"
                                ? _c("el-date-picker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: item.placeholder,
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    model: {
                                      value: _vm.educationForm[item.value],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.educationForm,
                                          item.value,
                                          $$v
                                        )
                                      },
                                      expression: "educationForm[item.value]",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "input"
                                ? _c("el-input", {
                                    attrs: {
                                      size: item.size || "small",
                                      clearable: "",
                                      placeholder: item.placeholder,
                                    },
                                    model: {
                                      value: _vm.educationForm[item.value],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.educationForm,
                                          item.value,
                                          $$v
                                        )
                                      },
                                      expression: "educationForm[item.value]",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              item.type === "textarea"
                                ? _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: _vm.educationForm[item.value],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.educationForm,
                                          item.value,
                                          $$v
                                        )
                                      },
                                      expression: "educationForm[item.value]",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitFnn()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }